import superagent from 'superagent';
import uuidv4 from 'uuid/v4';

import * as types from './types';
import utils from '../lib/utils';
import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function setPreferenceStart() {
  return {
    type: types.SET_PREFERENCES_START,
  };
}

export function setPreferenceSuccess({ preferences }) {
  return {
    type: types.SET_PREFERENCES_SUCCESS,
    preferences,
  };
}

export function setPreferenceFail() {
  return {
    type: types.SET_PREFERENCES_FAIL,
  };
}

export function getPreferenceStart() {
  return {
    type: types.GET_PREFERENCES_START,
  };
}

export function getPreferenceSuccess({
  preferences,
  paymentTypes,
  insurances,
  amenities,
  recipients,
}) {
  return {
    type: types.GET_PREFERENCES_SUCCESS,
    preferences,
    paymentTypes,
    insurances,
    amenities,
    recipients,
  };
}

export function getFreePricingPlansSuccess(response) {
  return {
    type: types.GET_FREE_PRICING_PLANS,
    response,
  };
}

export function getPreferenceFail() {
  return {
    type: types.GET_PREFERENCES_FAIL,
  };
}

export function setPreferences({ preferences }) {
  return (dispatch, getState) => {
    dispatch(setPreferenceStart());
    let bzSw = utils.getCookie('booking_software');
    // if(bzSw=='MYTIME'){
    // delete preferences.appointment_preferences.cc_not_on_file_action;
    // }
    if (bzSw === 'ACUITY' || bzSw === 'POREST') {
      delete preferences.appointment_preferences.cc_not_on_file_action;
      delete preferences.appointment_preferences.cc_for_coupons;
      delete preferences.appointment_preferences.collect_credit_card;
    }
    const { auth } = getState();
    const params = Object.assign(preferences, {
      id: auth.userid,
    });

    for (let key in params.preferences) {
      if (params.hasOwnProperty(key)) {
        params.preferences[key] = params[key];
      }
    }

    // for (let key in params.preferences) {
    //   params.preferences[key] = params[key]
    //     ? params[key]
    //     : params.preferences[key];
    // }
    // Object.keys(params.preferences).map(key=>{
    //   params.preferences[key] = params[key];
    // });

    const readyPref = {
      client_notification_preferences: params.client_notification_preferences,
      preferences: params.preferences,
    };
    request
      .post(`${window.Config.API_URL}/business/preferences`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(readyPref)
      .then(() => {
        dispatch(setPreferenceSuccess({ preferences }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(setPreferenceFail());
      });
  };
}

export function setDentalPreferences({ preferences }) {
  console.log('preferences', preferences);
  return (dispatch, getState) => {
    dispatch(setPreferenceStart());

    const {
      auth,
      preferences: { details },
    } = getState();
    const catchErr = (ex) => {
      console.log(ex);
      dispatch(setPreferenceFail());
    };
    console.log('preferences 1', preferences);
    const readyPref = {
      id: {
        id: auth.userid,
        billing: preferences.billing,
        faqs: preferences.faqs,
        custom_requests: preferences.custom_requests,
        emergency_notification: preferences.emergency,
        general_enquiries: preferences.general,
        amenities: preferences.services.amenities,
        general_information: preferences.general_information,
        calls_and_messaging: preferences.calls_and_messaging,
        notifications: preferences.notifications,
        scheduling: preferences.scheduling,
        pharmacy_records: preferences.pharmacy_records,
        insurance: preferences.insurance,
      },
      client_notification_preferences:
        preferences.client_notification_preferences,
      preferences: preferences.preferences,
    };
    delete preferences.scheduling.reschedule_appt_within_24hrs;
    delete preferences.scheduling.reschedule_charges;
    delete preferences.scheduling.cancel_appt_within_24hrs;
    delete preferences.scheduling.cancellation_charges;
    request
      .post(`${window.Config.API_URL}/business/dental/preferences/all`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(readyPref)
      .then(() => {
        dispatch(setPreferenceSuccess({ preferences: readyPref }));
      })
      .catch(catchErr);
  };
}

export function getPreferences() {
  return (dispatch) => {
    dispatch(getPreferenceStart());
    request
      .get(`${window.Config.API_URL}/business/preferences`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getPreferenceSuccess({ preferences: JSON.parse(resp.text) }));
        dispatch(checkVersionMisMatch(resp.headers));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getPreferenceFail());
      });
  };
}

export function getPreferenceSchemaStart() {
  return {
    type: types.GET_PREFERENCE_SCHEMA_START,
  };
}

export function getPreferenceSchemaSuccess({ preferences }) {
  return {
    type: types.GET_PREFERENCE_SCHEMA_SUCCESS,
    preferences,
  };
}

export function getPreferenceSchemaFail() {
  return {
    type: types.GET_PREFERENCE_SCHEMA_FAIL,
  };
}

export function getPreferenceSchema() {
  return (dispatch) => {
    dispatch(getPreferenceSchemaStart());
    request
      .get(`${window.Config.API_URL}/business/preferences/schema`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(
          getPreferenceSchemaSuccess({ preferences: JSON.parse(resp.text) }),
        );
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getPreferenceSchemaFail());
      });
  };
}

export function getFreePricingPlans() {
  return (dispatch) => {
    // dispatch(getFreePricingPlansStart());
    request
      .get(`${window.Config.API_URL}/business/preference/pricing`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(
          getFreePricingPlansSuccess({ pricing_plan: JSON.parse(resp.text) }),
        );
      })
      .catch((ex) => {
        console.log(ex);
        // dispatch(getFreePricingPlansFail());
      });
  };
}

export function getDentalPreferences() {
  return (dispatch, getState) => {
    dispatch(getPreferenceStart());
    const { auth } = getState();
    const catchErr = (ex) => {
      console.log(ex);
      dispatch(getPreferenceFail());
    };
    const ret = {};
    Promise.all([
      request
        .get(`${window.Config.API_URL}/business/dental/preferences/all`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.preferences = res.body;
          dispatch(checkVersionMisMatch(res.headers));
        })
        .catch(catchErr),
      request
        .get(`${window.Config.API_URL}/business/dental/types/payment`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.paymentTypes = res.body;
        })
        .catch(catchErr),
      request
        .get(`${window.Config.API_URL}/business/dental/types/insurance/all`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.insurances = res.body.map((ins) => {
            return {
              label: ins.name,
              value: ins.name,
            };
          });
        })
        .catch(catchErr),
      request
        .get(`${window.Config.API_URL}/business/dental/types/amenity`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.amenities = res.body;
        })
        .catch(catchErr),
      request
        .get(
          `${window.Config.API_URL}/business/dental/types/specialoffer/recipient`,
        )
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .then((res) => {
          ret.recipients = res.body;
        })
        .catch(catchErr),
    ])
      // .then((resp) => {
      // dispatch(getPreferenceSuccess({ preferences: JSON.parse(resp.text) }));
      .then(() => {
        dispatch(getPreferenceSuccess(ret));
      });
  };
}

export function getGroupIntentStart() {
  return {
    type: types.GET_GROUP_INTENT_START,
  };
}

export function getGroupIntentSuccess(intents) {
  return {
    type: types.GET_GROUP_INTENT_SUCCESS,
    intents,
  };
}

export function getGroupIntentFail() {
  return {
    type: types.GET_GROUP_INTENT_FAIL,
  };
}

export function getGroupIntent() {
  return (dispatch, getState) => {
    dispatch(getGroupIntentStart());
    let domain = utils.getCookie('domain');
    let booking_software = utils.getCookie('booking_software');
    request
      .get(
        `${window.Config.API_URL}/group_intent/get/domain/${domain}/booking_software/${booking_software}`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((res) => {
        dispatch(getGroupIntentSuccess(res.body));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(setPreferenceFail());
      });
  };
}
